<header
  *ngIf="configurationService.isTabletOrLarger$ | async"
  id="header"
  class="header header-bg-transparent header-abs-top d-lg-none"
>
  <div class="header-section">
    <div class="container-fluid">
      <!-- Nav -->
      <nav class="navbar header-navbar" aria-label="Main menu">
        <!-- Default Logo -->
        <div
          class="d-flex d-lg-none navbar-brand header-navbar-brand header-navbar-brand-collapsed"
        >
          <img
            [src]="primaryWhiteLogoUrl$ | async"
            *ngIf="primaryWhiteLogoUrl$ | async"
            class="branding__primary-logo d-none d-lg-flex"
            alt="Logo"
            width="50"
          />
          <img
            [src]="primaryLogoUrl$ | async"
            *ngIf="primaryLogoUrl$ | async"
            class="branding__primary-mobile d-flex d-lg-none mt-3"
            alt="Logo"
            width="50"
          />
        </div>
        <!-- End Default Logo -->

        <div class="ms-auto me-md-3">
          <language-switcher
            id="page-component-language-switcher"
          ></language-switcher>
        </div>
      </nav>
      <!-- End Nav -->
    </div>
  </div>
</header>

<main id="" class="h-100">
  <div class="container-fluid position-relative h-100">
    <div class="row h-100">
      <!-- Company side -->

      <div
        *ngIf="!(configurationService.isMobileApp$ | async)"
        data-test-id="company-side"
        class="branding__container col-md-5 col-12 d-md-flex flex-column justify-content-between position-md-fixed top-0 bottom-0 order-2 order-md-1 bg-header p-4"
      >
        <ng-container *ngIf="!(showBlankPage$() | async)">
          <!-- White Logo -->
          <div class="d-flex d-md-flex navbar-brand">
            <img
              class="branding__primary-logo m-auto"
              *ngIf="primaryWhiteLogoUrl$ | async"
              [src]="primaryWhiteLogoUrl$ | async"
              alt="logo"
            />
          </div>
          <!-- End White Logo -->

          <!-- company branding-->
          <div class="my-2 my-md-0 d-none d-lg-block">
            <div
              [innerHTML]="landingPageBrandingContent$ | async"
              class="overflow-auto"
            ></div>

            <p
              *ngIf="
                !(landingPageBrandingContent$ | async) &&
                !(configIsLoading$ | async)
              "
            >
              Set configOption per language such as en_landing_page_branding
            </p>
          </div>
          <!-- END company branding-->

          <!-- Bottom Links -->
          <div class="text-center p-md-5 text-center p-5">
            <div [innerHTML]="termsConditionsHTML$ | async"></div>
            <p
              *ngIf="
                !(termsConditionsHTML$ | async) && !(configIsLoading$ | async)
              "
            >
              Set configOption per language such as en_terms_conditions_footer
            </p>
            <div class="text-white small nav-link py-2">
              <a href="https://www.delcom.nl/" target="_blank">
                &copy; Powered by Delcom</a
              >
            </div>
          </div>
          <!-- End Bottom Links -->
        </ng-container>
      </div>
      <!-- END Company side -->

      <!-- Inserted page page-->
      <div class="col-12 offset-md-5 col-md order-md-2 d-flex pt-8 pt-md-0">
        <div class="container py-3 py-md-5 px-0">
          <div
            *ngIf="showPublicHeader$ | async"
            class="row d-lg-block"
          >
            <primary-navbar-non-logged-in></primary-navbar-non-logged-in>
          </div>

          <router-outlet></router-outlet>
        </div>
      </div>
      <!-- END Inserted page-->
    </div>
  </div>
</main>

<footer-component *ngIf="showFooter$ | async"></footer-component>
